import { SET_SESSION_NONCE } from './consts'

// Auth0 bearer mode (PD-27768): store the Auth0 access token in the session
// nonce slot so client.js sends it as `Authorization: Bearer`.
export default function setSessionNonce(nonce) {
  return { type: SET_SESSION_NONCE, nonce }
}
